//formatConjection: composes strings into a string separated with `,`
//@remarks Implementation comes from @stuart's prototype for PP-17345
export const formatConjunction = (array: string[], charLimit = 45): string => {
  if (!array.length) return '';
  let string = '';
  let curLen = 0;
  let remaining = array.length; // Track remaining items
  for (const item of array) {
    const newLen = curLen + item.length + 2; // +2 accounts for ', '
    if (newLen > charLimit) {
      // If adding this item would exceed the limit, stop and indicate remaining items
      break;
    }
    if (curLen) string += ', '; // Not first item, add ', '
    string += item;
    curLen = newLen;
    remaining--;
  }
  // Indicate any remaining items, or return the created string if none left
  return remaining ? `${string} and ${remaining} more` : string;
};

export const formatConjunctionWithTerm = (
  array: string[],
  term: string,
  charLimit = 100,
): string => {
  if (!array.length) return '';

  if (array.length === 1) {
    return array[0];
  }

  // Special case for exactly two items
  if (array.length === 2) {
    return `${array[0]} ${term} ${array[1]}`;
  }

  let string = '';
  let curLen = 0;
  let remaining = array.length; // Track remaining items
  for (const item of array) {
    const newLen =
      remaining === 1
        ? curLen + item.length + 6 // +6 accounts for ', and '
        : curLen + item.length + 2; // +2 accounts for ', '
    if (newLen > charLimit) {
      // If adding this item would exceed the limit, stop and indicate remaining items
      break;
    }
    if (curLen) string += ', '; // Not first item, add ', '
    if (remaining === 1) {
      // If exactly one item remaining, add 'and'
      string += `${term} `;
    }
    string += item;
    curLen = newLen;
    remaining--;
  }

  // Indicate any remaining items, or return the created string if none left
  return remaining ? `${string} ${term} ${remaining} more` : string;
};

//formatConjection: composes strings into a string separated with `,` and final `and`.
export const formatConjunctionWithAnd = (
  array: string[],
  charLimit = 100,
): string => {
  return formatConjunctionWithTerm(array, 'and', charLimit);
};
